/* tslint:disable */
/* eslint-disable */
/**
 * OMB Api
 * This file contains the information needed to generate all Api calls for the project.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputResponse
 */
export interface InputResponse {
    /**
     * 
     * @type {boolean}
     * @memberof InputResponse
     */
    error?: boolean;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof InputResponse
     */
    problems?: { [key: string]: string; };
    /**
     * 
     * @type {object}
     * @memberof InputResponse
     */
    data?: object;
}

export function InputResponseFromJSON(json: any): InputResponse {
    return InputResponseFromJSONTyped(json, false);
}

export function InputResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'error': !exists(json, 'error') ? undefined : json['error'],
        'problems': !exists(json, 'problems') ? undefined : json['problems'],
        'data': !exists(json, 'data') ? undefined : json['data'],
    };
}

export function InputResponseToJSON(value?: InputResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'error': value.error,
        'problems': value.problems,
        'data': value.data,
    };
}


